// Lista de categorias do marketplace - usada em filtros, formularios
// de cadastro de equipamento e tela de Categorias.
//
// Ícones 3D (pedido do dono, 25/09/2026): os ícones de linha (lucide) eram
// genéricos demais ao lado dos grandes players. Cada categoria tem um ícone 3D
// no estilo Fluent Emoji da Microsoft (licença MIT), 256 px com fundo
// transparente, em webp (3 a 9 KB cada). Os originais em png ficam na pasta
// icones-3d-categorias/ na raiz do projeto (fora do bundle).
import icoConstrucao from "../assets/categorias/construcao-civil.webp";
import icoSaude from "../assets/categorias/saude.webp";
import icoFestas from "../assets/categorias/festas.webp";
import icoModa from "../assets/categorias/moda.webp";
import icoFerramentas from "../assets/categorias/ferramentas.webp";
import icoAudioVideo from "../assets/categorias/audio-video.webp";
import icoVeiculos from "../assets/categorias/veiculos.webp";
import icoTech from "../assets/categorias/tech.webp";
import icoCasaJardim from "../assets/categorias/casa-jardim.webp";
import icoEsportes from "../assets/categorias/esportes.webp";
import icoInfantil from "../assets/categorias/infantil.webp";
import icoMusica from "../assets/categorias/musica.webp";
import icoEletronicos from "../assets/categorias/eletronicos.webp";
import icoCamping from "../assets/categorias/camping.webp";
import icoVerTodas from "../assets/categorias/ver-todas.webp";

// Ícone do atalho "Ver todas" (caixa), mesmo estilo das categorias.
export const ICONE_VER_TODAS = icoVerTodas;

export const CATEGORIAS = [
  { id: 1, nome: 'Construção Civil', icone3d: icoConstrucao, n: 1245, img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&q=80' },
  { id: 2, nome: 'Saúde', icone3d: icoSaude, n: 389, img: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=400&q=80' },
  { id: 3, nome: 'Festas', icone3d: icoFestas, n: 823, img: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=400&q=80' },
  { id: 4, nome: 'Moda', icone3d: icoModa, n: 1567, img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&q=80' },
  { id: 5, nome: 'Ferramentas', icone3d: icoFerramentas, n: 978, img: 'https://images.unsplash.com/photo-1581147036324-c17ac41f3ecd?w=400&q=80' },
  { id: 6, nome: 'Áudio/Vídeo', icone3d: icoAudioVideo, n: 534, img: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=400&q=80' },
  { id: 7, nome: 'Veículos', icone3d: icoVeiculos, n: 412, img: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&q=80' },
  { id: 8, nome: 'Tech', icone3d: icoTech, n: 267, img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&q=80' },
  { id: 9, nome: 'Casa/Jardim', icone3d: icoCasaJardim, n: 456, img: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&q=80' },
  { id: 10, nome: 'Esportes', icone3d: icoEsportes, n: 312, img: 'https://images.unsplash.com/photo-1461896836934-28d0e9e5ec21?w=400&q=80' },
  { id: 11, nome: 'Infantil', icone3d: icoInfantil, n: 189, img: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&q=80' },
  { id: 12, nome: 'Música', icone3d: icoMusica, n: 143, img: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&q=80' },
  { id: 13, nome: 'Eletrônicos', icone3d: icoEletronicos, n: 278, img: 'https://images.unsplash.com/photo-1468495244123-6c6c332eeece?w=400&q=80' },
  { id: 14, nome: 'Camping', icone3d: icoCamping, n: 167, img: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=400&q=80' },
];
